import { Link } from "react-router-dom";
import { MapPin, CalendarDays, UtensilsCrossed, Gift, Leaf, ArrowRight } from "lucide-react";
import { OliveAvailabilityForm } from "@/components/OliveAvailabilityForm";

const HIGHLIGHTS = [
  { icon: MapPin, label: "Luogo", value: "Uliveto ad Asciano · punto di ritrovo da comunicare" },
  { icon: CalendarDays, label: "Data proposta", value: "Sabato 3 ottobre 2026 · da confermare" },
  { icon: UtensilsCrossed, label: "Pranzo", value: "Offerto dall'associazione" },
  { icon: Gift, label: "Per ogni volontario", value: "Una bottiglietta dell'olio prodotto, quando disponibile" },
];

export const OlioSection = () => (
  <section id="olio" data-testid="home-olio" className="relative py-20 sm:py-28 bg-[#1f2d22] text-white overflow-hidden">
    <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #E8C9A0 1px, transparent 0)", backgroundSize: "28px 28px" }} />
    <div className="pointer-events-none absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full bg-[#6B8E3F]/20 blur-3xl" />
    <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
      <div>
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
          <Leaf className="w-3.5 h-3.5 text-[#E8C9A0]" />
          <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">Raccolta delle olive</span>
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.05] tracking-tight">
          Dall'oliveto recuperato, <span className="italic font-light text-[#E8C9A0]">un olio che aiuta Asciano.</span>
        </h2>
        <div className="mt-6 space-y-4 text-white/85 leading-relaxed text-sm sm:text-base max-w-xl">
          <p>Dopo esserci presi cura dell'oliveto, vogliamo tornare insieme tra gli ulivi per raccoglierne i frutti e produrre l'olio di Per Asciano.</p>
          <p>L'olio verrà venduto e i proventi contribuiranno a finanziare la pulizia e il recupero degli uliveti e le altre attività dell'associazione.</p>
          <p>Sarà un'occasione per lavorare insieme, stare all'aperto e condividere un momento di comunità. L'associazione offrirà il pranzo ai partecipanti e riserverà una bottiglietta dell'olio prodotto a ogni volontario, da consegnare quando sarà disponibile.</p>
        </div>
        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {HIGHLIGHTS.map((h) => {
            const Icon = h.icon;
            return (
              <div key={h.label} className="rounded-2xl bg-white/8 border border-white/15 p-4">
                <Icon className="w-5 h-5 text-[#E8C9A0] mb-2" />
                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E8C9A0]">{h.label}</div>
                <div className="mt-1 text-sm text-white/90 leading-snug">{h.value}</div>
              </div>
            );
          })}
        </div>
        <Link to="/raccolta-olive" data-testid="olio-page-link" className="mt-8 inline-flex items-center gap-2 text-[#E8C9A0] font-bold hover:gap-3 transition-all">
          Scopri tutti i dettagli della raccolta <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="lg:sticky lg:top-24">
        <OliveAvailabilityForm variant="light" />
      </div>
    </div>
  </section>
);
